var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.component,
    _vm._g(
      _vm._b(
        {
          ref: "button",
          tag: "component",
          class: _vm.classes,
          attrs: {
            to: _vm.to || null,
            type: _vm.type,
            href: _vm.isExternal && _vm.to,
            disabled: _vm.isLoading || _vm.disabled
          },
          on: {
            mouseenter: function($event) {
              _vm.showPopover = true
            },
            mouseleave: function($event) {
              _vm.showPopover = false
            }
          }
        },
        "component",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.icon && !_vm.isLoading
        ? _c("c-icon", {
            staticClass: "icon",
            attrs: { width: "15", height: "15", icon: _vm.icon }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading
        ? _c("c-spinner", { staticClass: "spinner", attrs: { size: "sm" } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isEmpty
        ? _c("span", { staticClass: "text" }, [_vm._t("default")], 2)
        : _vm._e(),
      _vm._v(" "),
      _vm.popoverLabel && _vm.showPopover
        ? _c(
            "c-popover",
            {
              staticClass: "popover",
              attrs: { position: ["top", "center"], target: _vm.$refs.button }
            },
            [_c("span", { domProps: { innerHTML: _vm._s(_vm.popoverLabel) } })]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3985b394", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3985b394","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CButton.vue
// module id = FK+0
// module chunks = 1624